<template>
  <div>
    <b-input-group class="mt-3 mb-3">
      <b-form-input placeholder="Search users" v-model="pesquisa"></b-form-input>
      <b-input-group-append>
        <b-button variant="light">
          <i class="fa fa-search fa-lg"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-list-group>
      <b-list-group-item
        v-for="p in participantesParaExcluir"
        :key="p.email"
        class="d-flex justify-content-between align-items-center"
      >
        <div>
          <img src="img/avatars/6.jpg" class="img-avatar mr-1" alt="admin@bootstrapmaster.com" />
          <span>{{ p.nome }}</span>
        </div>
        <b-btn variant="danger" @click="remover(p)">X</b-btn>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      pesquisa: undefined,
    };
  },
  computed: {
    ...mapGetters(['chatAtual', 'usuarioLogado']),
    participantesParaExcluir() {
      const participantes = this.chatAtual.participantes.filter(
        (p) => this.usuarioLogado.email != p.email,
      );
      if (this.pesquisa) {
        return participantes.filter((p) => p.nome.toUpperCase().includes(this.pesquisa.toUpperCase()));
      }
      return participantes;
    },
  },
  methods: {
    ...mapActions(['tirarDoChat']),
    async remover(participante) {
      try {
        await this.tirarDoChat({
          idChat: this.chatAtual.id,
          emailParticipante: participante.email,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
</style>
